<div class="main">
  <div class="heading">
    <h6>Could be Better Category</h6>
  </div>
  <!-- <div class="legend">
    <div class="sub-legend"><div class="notOk-wfo"></div> WFO ({{notOkData?.wfocount.toLocaleString('en-US')}})</div>
    <div class="sub-legend"><div class="notOk-wfa"></div> WFA ({{notOkData?.wfhcount.toLocaleString('en-US')}})</div>
  </div> -->
  <div class="graph">
    <div
      echarts
      [options]="gaugeOption"
      [initOpts]="{ renderer: 'canvas' }"
      class="demo-chart"
    ></div>
  </div>
</div>
